import { NgModule } from "@angular/core";
import { S25RegisterButtonComponent } from "./s25.register.button.component";
import { CommonModule } from "@angular/common";

import { S25IconComponent } from "../s25-icon/s25.icon.component";

@NgModule({
    declarations: [S25RegisterButtonComponent],
    imports: [CommonModule, S25IconComponent],
    providers: [S25RegisterButtonComponent],
    exports: [S25RegisterButtonComponent],
})
export class S25RegisterButtonModule {
    constructor() {}
}
